import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { MediaSection } from '@polestar/component-warehouse-react/components/section/Section';
import Spacings, { createCustomSpacing, } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import { useSSRSafeId } from '@polestar/component-warehouse-react/contexts/ssr';
import { CrossAxisAlignments, MainAxisAlignments, } from '@polestar/component-warehouse-react/tokens/alignments/Alignments';
import { maximumStretchedWidth, maximumWidth, } from '@polestar/component-warehouse-react/tokens/breakpoints/Breakpoints';
import { responsiveStyles } from '@polestar/component-warehouse-react/helpers/responsiveStyle';
import Grids from '@polestar/component-warehouse-react/tokens/grids/Grids';
const ImporterBannerTop = forwardRef(({ message, hasMaxWidth = false, ...props }, ref) => {
    const memoizedId = useSSRSafeId('importer-top-banner', props.id);
    return (React.createElement(ImporterBannerTopMediaSection, { ...props, ref: ref, id: memoizedId, hasMaxWidth: hasMaxWidth },
        React.createElement(Wrapper, null,
            React.createElement(Message, null, message))));
});
ImporterBannerTop.displayName = 'ImporterBannerTop';
export default ImporterBannerTop;
const ImporterBannerTopMediaSection = styled(MediaSection)(({ theme, hasMaxWidth }) => css(css `
      background-color: ${theme.importerTopBanner.background};

      ${responsiveStyles({
    padding: {
        mobile: `0 ${Grids.mobile.gutter}`,
        tablet: `0 ${Grids.tablet.gutter}`,
        desktop: `0 ${Grids.desktop.gutter}`,
    },
})}
    `, !hasMaxWidth &&
    css `
        max-width: unset;
      `, hasMaxWidth &&
    css `
        max-width: ${maximumStretchedWidth};
      `));
const Wrapper = styled.div(({ theme }) => css `
    margin: 0 auto;
    position: relative;
    color: ${theme.importerTopBanner.color};
    display: flex;
    flex-wrap: wrap;
    justify-content: ${MainAxisAlignments.center};
    align-items: ${CrossAxisAlignments.center};
    width: 100%;
    text-decoration: none;
    text-align: center;

    ${responsiveStyles({
    padding: {
        mobile: `${createCustomSpacing(13 / 16)} ${Grids.mobile.gutter}`,
        tablet: `${createCustomSpacing(13 / 16)} ${Spacings.large}`,
        desktop: `${createCustomSpacing(13 / 16)} ${Spacings.xLarge}`,
        desktopWide: `${createCustomSpacing(13 / 16)} ${Spacings.xxxxLarge}`,
    },
    maxWidth: {
        mobile: '100%',
        desktopWide: `${maximumWidth}px`,
    },
})},
  `);
const Message = styled.p `
  font-size: ${Spacings.small};
  line-height: ${createCustomSpacing(14 / 16)};
`;
